<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"  
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"  
       style="margin-right: 10px; cursor: pointer; font-size: 18px;"  
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer; font-size: 18px;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li 
        [class.active]="tab.id === activeTab"
        [class.disabled]="tab.disabled">
      <a (click)="!tab.disabled && (activeTab = tab.id)" 
         [style.cursor]="tab.disabled ? 'not-allowed' : 'pointer'" 
         class="btn-sm"
         [class.disabled-tab]="tab.disabled">
        {{ tab.name }}
      </a>
    </li>
}
  </ul>

  <div class="tab-content" style="margin-top: 20px;">
    <!-- Form Entry Tab -->
    @if (activeTab === 1) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      <div class="form-horizontal">
        @if (showFormLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}
        
        @if (!showFormLoader) {
<div>
          <!-- Entity Information Table -->
          <table class="table table-bordered form-inline enityDetails custom-table" style="margin-bottom: 25px;">
            <tr>
              @for (item of entityList; track $index) {
<td>
                <span><strong>{{ item.key }}</strong></span>
              </td>
}
            </tr>
            <tr>
              @for (item of entityList; track $index) {
<td>
                <span>{{ item.value }}</span>
              </td>
}
            </tr>
          </table>
          
          <!-- Main Schedule G Form Table -->
          <div class="scheduleGTableBlock">
            <table class="table table-bordered form-inline custom-table">
              <thead>
                <tr>
                  <th colspan="11">{{ modalTitle }}</th>
                </tr>
                <tr>
                  <th colspan="5">Consolidated</th>
                  <th colspan="3">Domestic</th>
                  <th colspan="3">Foreign</th>
                </tr>
                <tr>
                  <th colspan="2"></th>
                  <th colspan="1">
                    <span class="schd-ins">(a) Annuity</span>
                  </th>
                  <th colspan="1">
                    <span class="schd-ins">(b) Group Life</span>
                  </th>
                  <th colspan="1">
                    <span class="schd-ins">(c) Other</span>
                  </th>
                  <th colspan="1">
                    <span class="schd-ins">(a) Annuity</span>
                  </th>
                  <th colspan="1">
                    <span class="schd-ins">(b) Group Life</span>
                  </th>
                  <th colspan="1">
                    <span class="schd-ins">(c) Other</span>
                  </th>
                  <th colspan="1">
                    <span class="schd-ins">(a) Annuity</span>
                  </th>
                  <th colspan="1">
                    <span class="schd-ins">(b) Group Life</span>
                  </th>
                  <th colspan="1">
                    <span class="schd-ins">(c) Other</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (row of scheduleGFormView.rows; track itemTracker(i, row); let i = $index) {
<tr>
                  <td style="vertical-align: middle; text-align: center; padding: 0 10px !important;">{{row.num}}</td>
                  
                  <!-- Description column with special handling for lines 9 and 19 -->
                  @if (row.num != 9 && row.num != 19) {
<td style="vertical-align: middle; padding-left: 6px !important;" 
                     >{{row.description}}</td>
}
                  @if (row.num == 9) {
<td style="vertical-align: middle; padding-left: 6px !important; cursor: pointer;" 
                      
                      [innerHTML]="getText(row.num, row.description)"
                      (click)="fetchSchGwhitepaper(row.num)"></td>
}
                  @if (row.num == 19) {
<td style="vertical-align: middle; padding-left: 6px !important; cursor: pointer;" 
                      
                      [innerHTML]="getText(row.num, row.description)"
                      (click)="fetchSchGwhitepaper(row.num)"></td>
}

                  <!-- Consolidated Column A (Annuity) -->
                  <td align="right">
                    @if (!(row.num > 5 || row.num == 4 || row.num == '15a' || row.num == '15b' || row.num == '17a' || row.num == '17b' || row.num == '18a' || row.num == '18b')) {
<div>
                      <input class="form-control input-sm numText"
                             type="number" 
                             [(ngModel)]="row.value1"
                             [disabled]="true"
                             aria-describedby="basic-addon2">
                    </div>
}
                    @if (row.num == 4) {
<div>
                      <input class="form-control input-sm" type="text" placeholder="2.09%" [disabled]="true">
                    </div>
}
                  </td>

                  <!-- Consolidated Column B (Group Life) -->
                  <td align="right">
                    @if (!((row.num > 5 && row.num <= 14) || row.num == 4 || row.num == '15b' || row.num == '17b' || row.num == '18b' || row.num >= 19)) {
<div>
                      <input class="form-control input-sm numText"
                             type="number" 
                             [(ngModel)]="row.value2"
                             [disabled]="true"
                             aria-describedby="basic-addon2">
                    </div>
}
                    @if (row.num == 4) {
<div>
                      <input class="form-control input-sm" type="text" placeholder="2.45%" [disabled]="true">
                    </div>
}
                    @if (row.num == '15b') {
<div>
                      <input [disabled]="true" placeholder="$10,000,000" class="form-control input-sm" type="text">
                    </div>
}
                  </td>

                  <!-- Consolidated Column C (Other) -->
                  <td align="right">
                    @if (!(row.num == 4 || row.num == '15a' || row.num == '15b' || row.num == '16' || row.num == '17a' || row.num == '18a')) {
<div>
                      <input class="form-control input-sm numText"
                             type="number" 
                             [(ngModel)]="row.value3"
                             [disabled]="true"
                             aria-describedby="basic-addon2">
                    </div>
}
                    @if (row.num == 4) {
<div>
                      <input class="form-control input-sm" type="text" placeholder="9.2%" [disabled]="true">
                    </div>
}
                  </td>

                  <!-- Domestic Column A (Annuity) -->
                  <td align="right">
                    @if (!(row.num > 5 || row.num == 4 || row.num == '15a' || row.num == '15b' || row.num == '17a' || row.num == '17b' || row.num == '18a' || row.num == '18b')) {
<div>
                      <input class="form-control input-sm numText"
                             type="number" 
                             [(ngModel)]="row.value4"
                             [disabled]="!row.is_editable"
                             (ngModelChange)="combinedComputeValues('domestic', false, false, row)"
                             aria-describedby="basic-addon2">
                    </div>
}
                    @if (row.num == 4) {
<div>
                      <input class="form-control input-sm" type="text" placeholder="2.09%" [disabled]="true">
                    </div>
}
                  </td>

                  <!-- Domestic Column B (Group Life) -->
                  <td align="right">
                    @if (!((row.num > 5 && row.num <= 14) || row.num == 4 || row.num == '15b' || row.num == '17b' || row.num == '18b' || row.num >= 19)) {
<div>
                      <input class="form-control input-sm numText"
                             type="number" 
                             [(ngModel)]="row.value5"
                             [disabled]="!row.is_editable"
                             (ngModelChange)="combinedComputeValues('domestic', false, false, row)"
                             aria-describedby="basic-addon2">
                    </div>
}
                    @if (row.num == 4) {
<div>
                      <input class="form-control input-sm" type="text" placeholder="2.45%" [disabled]="true">
                    </div>
}
                    @if (row.num == '15b') {
<div>
                      <input [disabled]="true" placeholder="$10,000,000" class="form-control input-sm" type="text">
                    </div>
}
                  </td>

                  <!-- Domestic Column C (Other) -->
                  <td align="right">
                    @if (!(row.num == 4 || row.num == '15a' || row.num == '15b' || row.num == '16' || row.num == '17a' || row.num == '18a')) {
<div>
                      <input class="form-control input-sm numText"
                             type="number" 
                             [(ngModel)]="row.value6"
                             [disabled]="!row.is_editable"
                             (ngModelChange)="combinedComputeValues('domestic', false, false, row)"
                             aria-describedby="basic-addon2">
                    </div>
}
                    @if (row.num == 4) {
<div>
                      <input class="form-control input-sm" type="text" placeholder="9.2%" [disabled]="true">
                    </div>
}
                  </td>

                  <!-- Foreign Column A (Annuity) -->
                  <td align="right">
                    @if (!(row.num > 5 || row.num == 4 || row.num == '15a' || row.num == '15b' || row.num == '17a' || row.num == '17b' || row.num == '18a' || row.num == '18b')) {
<div>
                      <input class="form-control input-sm numText"
                             type="number" 
                             [(ngModel)]="row.value7"
                             [disabled]="!row.is_editable"
                             (ngModelChange)="combinedComputeValues('foreign', false, false, row)"
                             aria-describedby="basic-addon2">
                    </div>
}
                    @if (row.num == 4) {
<div>
                      <input class="form-control input-sm" type="text" placeholder="2.09%" [disabled]="true">
                    </div>
}
                  </td>

                  <!-- Foreign Column B (Group Life) -->
                  <td align="right">
                    @if (!((row.num > 5 && row.num <= 14) || row.num == 4 || row.num == '15b' || row.num == '17b' || row.num == '18b' || row.num >= 19)) {
<div>
                      <input class="form-control input-sm numText"
                             type="number" 
                             [(ngModel)]="row.value8"
                             [disabled]="!row.is_editable"
                             (ngModelChange)="combinedComputeValues('foreign', false, false, row)"
                             aria-describedby="basic-addon2">
                    </div>
}
                    @if (row.num == 4) {
<div>
                      <input class="form-control input-sm" type="text" placeholder="2.45%" [disabled]="true">
                    </div>
}
                    @if (row.num == '15b') {
<div>
                      <input [disabled]="true" placeholder="$10,000,000" class="form-control input-sm" type="text">
                    </div>
}
                  </td>

                  <!-- Foreign Column C (Other) -->
                  <td align="right">
                    @if (!(row.num == 4 || row.num == '15a' || row.num == '15b' || row.num == '16' || row.num == '17a' || row.num == '18a')) {
<div>
                      <input class="form-control input-sm numText"
                             type="number" 
                             [(ngModel)]="row.value9"
                             [disabled]="!row.is_editable"
                             (ngModelChange)="combinedComputeValues('foreign', false, false, row)"
                             aria-describedby="basic-addon2">
                    </div>
}
                    @if (row.num == 4) {
<div>
                      <input class="form-control input-sm" type="text" placeholder="9.2%" [disabled]="true">
                    </div>
}
                  </td>
                </tr>
}
              </tbody>
            </table>
          </div>
        </div>
}
        
        <!-- Unallocated Amount Section -->
        @if (!showFormLoader && unallocatedAmountData && unallocatedAmountData.length > 0) {
<div>
          <table class="table table-bordered form-inline unallocated-amount-table">
            <tbody>
              @for (row of unallocatedAmountData; track $index; let rowIndex = $index) {
<tr>
                @for (col of row; track $index; let colIndex = $index) {
<td width="25%">
                  <span class="bg-grey">
                    @if (colIndex < 3) {
<span>( {{col.name}} )</span>
}
                    @if (colIndex == 3) {
<span>(Exception?) : 
                      <input type="checkbox" 
                             [ngModel]="col.exception_flag === 'Y'" 
                             (ngModelChange)="col.exception_flag = $event ? 'Y' : 'N'"
                             [disabled]="row[colIndex-1].value == 0">
                      <span class="diag_check"> By Pass Diag.</span>
                    </span>
}
                  </span>
                  <br>
                  @if (colIndex < 3) {
<span [ngClass]="{'color-red' : col.value < 0 }">
                    <span>{{col.value | number}}</span>
                  </span>
}
                  @if (colIndex == 3) {
<span>
                    <span>Exception Reason : </span>
                    <span><input type="text" 
                                 class="form-control exception_input" 
                                 [ngClass]="{'input_disabled': col.exception_flag==='N'}" 
                                 name="exceptionMsg" 
                                 [(ngModel)]="col.exception_msg" 
                                 [disabled]="col.exception_flag==='N'"></span>
                  </span>
}
                </td>
}
              </tr>
}
            </tbody>
          </table>
        </div>
}
      </div>
    </div>
}

    <!-- Form View Tab -->
    @if (activeTab === 2) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      @if (showFormLoader) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}
      @if (!showFormLoader) {
<div class="L_SCHD_G">
        <table>
          <thead>
            <tr>
              <th colspan="5">
                <span class="schd-name">Schedule G</span>
                <span class="schd-desc">Policy Acquisition Expenses</span>
                <span class="schd-ins">(section 848) (see instructions)</span>
              </th>
            </tr>
            <tr>
              <th colspan="2"></th>
              <th colspan="1" class="subHeader">
                <span class="schd-sub">(a) Annuity</span>
              </th>
              <th colspan="1" class="subHeader">
                <span class="schd-sub">(b) Group life insurance</span>
              </th>
              <th colspan="1" class="subHeader">
                <span class="schd-sub">(c) Other</span>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (row of scheduleGFormView.rows; track itemTracker($index, row)) {
<tr>
              <td class="lineNo">{{row.num}}</td>
              <td class="lineDesc">{{row.description}}</td>
              <td>
                @if (!(row.num > 5 || row.num == '15a' || row.num == '15b' || row.num == '17a' || row.num == '17b' || row.num == '18a' || row.num == '18b')) {
<div [ngClass]="{'color-red': row.value1 < 0 }" 
                     class="input_enabled" 
                    >
                  {{row.value1 | number}}
                </div>
}
              </td>
              <td>
                @if (!((row.num > 5 && row.num <= 14) || row.num == '15b' || row.num == '17b' || row.num == '18b' || row.num >= 19)) {
<div [ngClass]="{'color-red': row.value2 < 0 }" 
                     class="input_enabled" 
                    >
                  {{row.value2 | number}}
                </div>
}
                @if (row.num == '15b') {
<input class="input_enabled" 
                       style="text-align: center;" 
                       [disabled]="!row.is_editable" 
                       placeholder="$10,000,000" 
                       
                       type="text">
}
              </td>
              <td style="text-align: right;">
                @if (!(row.num == '15a' || row.num == '15b' || row.num == '17a' || row.num == '16' || row.num == '18a')) {
<div [ngClass]="{'color-red': row.value3 < 0 }" 
                    >
                  {{row.value3 | number}}
                </div>
}
                @if (row.num == '15a' || row.num == '15b' || row.num == '17a' || row.num == '16' || row.num == '18a') {
<input class="input_disabled" 
                       
                       [disabled]="true">
}
              </td>
            </tr>
}
          </tbody>
        </table>
      </div>
}
    </div>
}

    <!-- Audit Tab -->
    @if (activeTab === 3) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      <div class="form-horizontal">
        @if (showRequestLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}
        @if (!showRequestLoader) {
<div class="main-header">
          <div class="col-sm-4">
            <span style="text-align: center; display: block;">Transaction Number</span>
          </div>
          <div class="col-sm-3">
            <span>User</span>
          </div>
          <div class="col-sm-2">
            <span>Date</span>
          </div>
          <div class="col-sm-3" style="padding-left: 20px">
            <span>View Transactions</span>
          </div>
        </div>
}
        @if (batchLoader) {
<div class="viewBatchLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}
        @for (batchItem of BatchList; track $index; let batchIndex = $index) {
<div class="audit-container">
          <div class="audit-row">              
            <div class="col-sm-4">
              <span style="text-align: center; display: block;">{{batchItem.TRANSACTION_ID}}</span>
            </div>
            <div class="col-sm-3">
              <span>{{batchItem.USER_FIRST_NAME}} {{batchItem.USER_LAST_NAME}}</span>
            </div>
            <div class="col-sm-2">
              <span>{{batchItem.CREATED_ON}}</span>
            </div>
            <div class="col-sm-3">                   
              <button type="button" 
                      class="btn btn-primary view-trans-btn" 
                      (click)="showUploads(batchIndex, batchItem.TRANSACTION_ID)" 
                      [disabled]="batchItem.show_transaction">
                View Transactions
              </button> 
              <span>@if (batchItem.show_transaction) {
<i class="fa fa-spinner fa-spin gt-refresh"></i>
}</span>
            </div>
          </div>
          @if (batchItem.TOGGLE) {
<div class="transaction-details">
            @if (batchLoader) {
<div class="viewBatchLoader">
              <i class="fa fa-spinner fa-spin gt-refresh"></i>
            </div>
}
            @if (showBatchData && BatchListData && BatchListData.length > 0) {
<table class="table table-bordered form-inline custom-table">
              <thead>
                <tr style="background: #cd5763;color: white;font-weight: bold;">
                  <td style="width: 58px;padding: 0 20px;">#</td>
                  <td style="padding: 0 20px;">Description</td>
                  <td style="width: 110px;padding: 0;text-align: center;">Column A</td>
                  <td style="width: 110px;padding: 0;text-align: center;">Column B</td>
                  <td style="width: 110px;padding: 0;text-align: center;">Column C</td>
                </tr>
              </thead>
              <tbody>
                @for (batchData of BatchListData; track itemTracker($index, batchData)) {
<tr>
                  <td style="width: 58px;padding: 0 20px;">{{batchData.LINE_NO}}</td>
                  <td style="padding: 0 20px;">{{batchData.LINE_DESCRIPTION}}</td>
                  <td style="width: 110px;padding: 0;" align="right">
                    <div style="background: white;border-radius: 4px;margin: 2px;text-align: center;">
                      {{batchData.ATTRIBUTE_VALUE | number:'1.0-0'}}
                    </div>
                  </td>
                  <td style="width: 110px;padding: 0;" align="right">
                    <div style="background: white;border-radius: 4px;margin: 2px;text-align: center;">
                      {{batchData.ATTRIBUTE_VALUE_B | number:'1.0-0'}}
                    </div>
                  </td>
                  <td style="width: 110px;padding: 0;" align="right">
                    <div style="background: white;border-radius: 4px;margin: 2px;text-align: center;">
                      {{batchData.ATTRIBUTE_VALUE_C | number:'1.0-0'}}
                    </div>
                  </td>
                </tr>
}
              </tbody>
            </table>
}
            <!-- Show message if no data -->
            @if (showBatchData && (!BatchListData || BatchListData.length === 0)) {
<div style="padding: 20px; text-align: center; color: #666;">
              No transaction data available
            </div>
}
          </div>
}
        </div>
}
      </div>
    </div>
}

    <!-- Whitepaper Info Tab -->
    @if (activeTab === 4) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      @if (showFormLoader) {
<div class="viewFormLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}

      @if (!showFormLoader && formWhitepaper && formWhitepaper.length > 0) {
<div class="PC_SCHD_A_Diag">
        <div class="col-md-12 diag-blocks">
          <div class="row slim-scroll-block" style="height: 580px; overflow-y: auto; background: lightgrey; margin: 0px 9px;">
            <table class="main_table">
              <thead>
                <tr>
                  <th colspan="3">
                    <span class="schd-name">Forms</span>
                  </th>
                  <th colspan="3"></th>
                </tr>
                <tr>
                  <th colspan="1" style="text-align: center;width: 42px;">
                    <span>#</span>
                  </th>
                  <th colspan="3">
                    <span>Forms Description</span>
                  </th>
                  <th colspan="2" class="amountColumn">
                    <span>Amount</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <!-- 1st Level Drilldown -->
                @for (row of formWhitepaper; track $index) {
<tr>
                  <td colspan="1" style="vertical-align: top; text-align: inherit;">{{row.LINE_NO}}</td>
                  @if (row.LINE_NO != 19) {
<td colspan="3" style="vertical-align: top; text-align: inherit;">
                    <span style="cursor: pointer;" (click)="row.toggleTotal = !row.toggleTotal">
                      @if (!row.toggleTotal) {
<span><i class="fa fa-plus-circle"></i></span>
} 
                      @if (row.toggleTotal) {
<span><i class="fa fa-minus-circle"></i></span>
}
                    </span> &nbsp; {{row.DESCRIPTION}}
                    
                    <!-- 2nd Level Drilldown -->
                    @if (row.toggleTotal) {
<div class="totalLines">
                      <table>
                        @for (total of row.totalLines; track $index) {
<tr>
                          <td style="vertical-align: top;">{{total.LINE_NO}}</td>
                          <td>
                            <div style="display: flex;">
                              <span>{{total.DESCRIPTION}}</span>
                              <!-- 3rd Level Drilldown -->
                              @if (total.toggle) {
<div class="childAcctBlock">
                                <ol>
                                  @for (child of total.childAcct; track $index) {
<li style="padding: 5px 26px;">
                                    {{child.DESCRIPTION}}
                                    <span class="amountBadge">{{child.AMOUNT}}</span>
                                  </li>
}
                                </ol>
                                @if (!total.childAcct || total.childAcct == undefined) {
<div style="padding: 0px 0px 8px 18px;">
                                  No Records Found
                                </div>
}
                              </div>
}
                            </div>
                          </td>
                          <td style="vertical-align: top;">
                            <span class="amountBadge">{{total.AMOUNT | number}}</span>
                          </td>
                        </tr>
}
                      </table>
                    </div>
}
                  </td>
}
                  @if (row.LINE_NO == 19) {
<td colspan="3"> &nbsp; DAC Amort Exp on Amts Cap. in PY</td>
}
                  <td colspan="2" style="text-align: right;vertical-align: top;">
                    <span class="amountBadge">{{row.AMOUNT | number}}</span>
                  </td>
                </tr>
}
              </tbody>
            </table>
          </div>
        </div>
      </div>
}

      @if (!showFormLoader && (!formWhitepaper || formWhitepaper.length == 0)) {
<div class="PC_SCHD_A_Diag">
        <div class="row" style="height:auto;">
          <table>
            <tbody>
              <tr>
                <td colspan="12">Whitepaper info unavailable.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
}
    </div>
}
  </div>
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  @if (currentTabName != 'Subsidiary') {
<button  
          class="btn btn-info btn-sm"  
          type="button"  
          [disabled]="isSaveClicked"  
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
}
  @if (currentTabName != 'Subsidiary') {
<button  
          class="btn btn-danger-outline btn-sm"  
          type="button"  
          (click)="reset()">Reset</button>
}
  <button class="btn btn-warning btn-sm"  
          type="button"  
          (click)="cancel()">Cancel</button>
</div>
